module.exports = __webpack_public_path__ + "static/media/01B.eb0d986a.png";